.root {
  position: relative;
  display: flex;
  width: 100%;
}

.favorite {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.inner {
  width: 100%;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.25rem;
  margin-bottom: 1rem;
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-regular);
}

.removed {
  padding: 1rem;
  padding-bottom: 1rem;
  background-color: var(--gray-100);
}

.similarGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.toggleSimilar {
  margin-top: 1rem;
  font-size: var(--font-size-body-2);
}

.lower {
  display: flex;
  justify-content: space-between;
}

.share {
  max-width: 190px;
  margin-top: auto;
  margin-left: auto;
}
